import React, { FC, useState } from 'react'
import { Container, Table } from 'react-bootstrap'
import { SimilarRecordModel } from '../../../models/applicationRegistration/fileRegistration/similarRecordModel'
import SimlarRecordViewModal from '../../modals/SimlarRecordViewModal'
import SimilerReasoningModal from '../../modals/SimilerReasoningModal'
import common from '../../../services/applicationRegistration/common'

export interface SimilarRecordTableProps {
  similarRecordList: any[]
  onClick?: any
}

const SimilarRecordTable: FC<SimilarRecordTableProps> = ({
  similarRecordList,
}) => {
  const [similarRecord, setSimilarRecord] = useState({} as SimilarRecordModel)
  const [showSimilarModal, setShowSimilarModal] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [selectedRecord, setSelectedRecord] = useState<any>({
    applicationReference: '',
    programType: '',
    scheme: '',
    descriptions: [],
  })
  const handleViewSimilarRecord = (record: any) => {
    if (record.isFromReppia) {
      setSimilarRecord(record.reppiaApplicationDetails)
      setShowSimilarModal(true)
    } else {
      const win = window.open(
        `/enquire-application/view/${record.orimsApplicationFileId}`,
        '_blank'
      )
      win.focus()
    }
  }

  const handleViewButtonClick = async (record: any) => {
    console.log(record)
    try {
      // Fetch similar record details using the file ID
      const response = await common.apiGetSimilarRecordSimilertyDetails(
        record.id
      )

      const data = response.data

      if (data && data.descriptions && data.descriptions.length > 0) {
        // Process descriptions to remove the "Similar records found with" prefix and "!" suffix
        const processedDescriptions = data.descriptions.map(
          (description: string) =>
            description
              .replace(/^Similar records found with\s*/, '')
              .replace(/!$/, '')
        )

        setSelectedRecord({
          applicationReference: data.applicationReference || record.mapFileNo,
          programType: data.programType,
          scheme: data.scheme,
          descriptions: processedDescriptions,
        })
      } else {
        // Handle the case where the API response is empty or has no descriptions
        setSelectedRecord({
          applicationReference: record.mapFileNo,
          programType: record.programType,
          scheme: record.scheme,
          descriptions: ['No similar records found.'],
        })
      }

      setShowModal(true)
    } catch (error) {
      console.error('Error fetching similar record details:', error)
      alert('Failed to fetch similar record details. Please try again later.')
    }
  }

  return (
    <>
      <Container fluid className="mt-4">
        <Table striped bordered hover size="sm">
          <thead className="custom-table-header">
            <tr>
              <th className="custom-table-header">Application Reference</th>
              <th className="custom-table-header">Program Type</th>
              <th className="custom-table-header">Scheme</th>
              <th className="custom-table-header">Applicant Name</th>
              <th className="custom-table-header">Created Date</th>
              <th className="custom-table-header">Status</th>
              <th className="custom-table-header">Actions</th>
            </tr>
          </thead>
          <tbody className="custom-table-body">
            {similarRecordList.map((record: any) => (
              <tr
                key={record.id}
                onClick={() => {
                  handleViewSimilarRecord(record)
                }}
              >
                <td className="td">
                  {record.isFromReppia
                    ? record.reppiaApplicationDetails.mapFileNo
                    : record.applicationReference}
                </td>
                <td className="td">{record.programType}</td>
                <td className="td">{record.scheme}</td>
                <td className="td">{record.applicantName}</td>
                <td className="td">
                  {record.createDateAndTime == null
                    ? 'N/A'
                    : new Date(
                        record.createDateAndTime * 1000
                      ).toLocaleDateString()}
                </td>
                <td className="td">{record.status}</td>
                <td className="td">
                  <button
                    className="view-similarty-button"
                    onClick={(e) => {
                      e.stopPropagation()
                      handleViewButtonClick(record)
                    }}
                  >
                    View
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Container>
      {showModal && (
        <SimilerReasoningModal
          show={showModal}
          onHide={() => setShowModal(false)}
          data={selectedRecord}
        />
      )}
      {showSimilarModal && (
        <SimlarRecordViewModal
          similarRecord={similarRecord}
          onCancel={() => {
            setShowSimilarModal(false)
          }}
        />
      )}
    </>
  )
}

export default SimilarRecordTable
